"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.get_production_keys = void 0;
const objectToQueryString_1 = require("../../../helpers/objectToQueryString");
const api_1 = require("../../api");
function get_production_keys(request) {
    var _a;
    return __awaiter(this, void 0, void 0, function* () {
        return yield new api_1.API().apiGet({
            baseUrl: (_a = process.env.FACETEC_API_URL) !== null && _a !== void 0 ? _a : "",
            endpoint: `production_keys${(0, objectToQueryString_1.objectToQueryString)(request)}`,
        });
    });
}
exports.get_production_keys = get_production_keys;
